<template>
  <div>
    <label class="typo__label">{{ stat_type_dropdown.label }}</label>
    <multiselect
      v-model="statType"
      select-label=""
      deselect-label=""
      track-by="id"
      label="text"
      @input="stat_type_change_func"
      :preselect-first="true"
      :options="stat_type_dropdown.data"
      :searchable="false"
      :show-labels="false"
      :allow-empty="false">
      <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'StatTypeSelect',
  components: {
    Multiselect
  },
  props: ['value', 'options', 'summary_table_data', 'table_data', 'summary_totals', 'totals', 'summary_per_100', 'table_per_100', 'summary_per_game', 'table_per_game', 'stat_table_data_options', 'summary_columns', 'columns', 'rate_stats_keys', 'stat_type_change_func'],
  data () {
    return {
      stat_type_dropdown: this.options,
      stat_type_selected: this.value,
      single_row_table_data: this.summary_table_data,
      multi_row_table_data: this.table_data,
      single_row_table_data_totals: this.summary_totals,
      multi_row_table_data_totals: this.totals,
      single_row_table_data_per_100: this.summary_per_100,
      multi_row_table_data_per_100: this.table_per_100,
      single_row_table_data_per_game: this.summary_per_game,
      multi_row_table_data_per_game: this.table_per_game,
      table_data_options: this.stat_table_data_options,
      single_row_table_columns: this.summary_columns,
      multi_row_table_columns: this.columns
    }
  },
  watch: {
    options: function (val) {
      this.stat_type_dropdown = val
    }
  },
  computed: {
    statType: {
      get () {
        return this.stat_type_selected
      },
      set (value) {
        this.stat_type_selected = value
        this.$emit('input', value)
      }
    }
  },
  methods: {
    setStatTypeValue () {
      this.stat_type_dropdown.data.forEach((statType) => {
        if (statType.id === this.$route.query.StatType) {
          this.stat_type_selected = statType
        }
      })
      if (!this.stat_type_selected) {
        this.stat_type_selected = this.stat_type_dropdown.data[0]
      }
    },
    changeStatType () {
      this.single_row_table_data = {}
      this.multi_row_table_data = {}
      var updatedColumns = {}
      var allTableData

      if (!this.stat_type_selected || this.stat_type_selected.id === 'Totals') {
        this.single_row_table_data = this.single_row_table_data_totals
        allTableData = this.multi_row_table_data_totals
        this.table_data_options.forEach((tableDataOption) => {
          this.single_row_table_columns[tableDataOption.id] = this.changeColumnType(this.single_row_table_columns[tableDataOption.id], 'totals_type')
          updatedColumns[tableDataOption.id] = this.changeColumnType(this.multi_row_table_columns[tableDataOption.id], 'totals_type')
        })
      } else if (this.stat_type_selected.id === 'Per100Possessions') {
        if (this.multi_row_table_data_per_100.length === 0) {
          this.multi_row_table_data_per_100 = this.convertAllRowsToPer100Possessions(this.multi_row_table_data_totals, this.table_data_options, this.multi_row_table_columns)
          this.single_row_table_data_per_100 = this.convertRowToPer100Possessions(this.single_row_table_data_totals)
        }
        this.single_row_table_data = this.single_row_table_data_per_100
        allTableData = this.multi_row_table_data_per_100
        this.table_data_options.forEach((tableDataOption) => {
          this.single_row_table_columns[tableDataOption.id] = this.changeColumnType(this.single_row_table_columns[tableDataOption.id], 'per_100_poss_type')
          updatedColumns[tableDataOption.id] = this.changeColumnType(this.multi_row_table_columns[tableDataOption.id], 'per_100_poss_type')
        })
      } else if (this.stat_type_selected.id === 'PerGame') {
        if (this.multi_row_table_data_per_game.length === 0) {
          this.multi_row_table_data_per_game = this.convertAllRowsToPerGame(this.multi_row_table_data_totals, this.table_data_options, this.multi_row_table_columns)
          this.single_row_table_data_per_game = this.convertRowToPerGame(this.single_row_table_data_totals)
        }
        this.single_row_table_data = this.single_row_table_data_per_game
        allTableData = this.multi_row_table_data_per_game
        this.table_data_options.forEach((tableDataOption) => {
          this.single_row_table_columns[tableDataOption.id] = this.changeColumnType(this.single_row_table_columns[tableDataOption.id], 'per_game_type')
          updatedColumns[tableDataOption.id] = this.changeColumnType(this.multi_row_table_columns[tableDataOption.id], 'per_game_type')
        })
      }

      var multiRowTableDataByTab = {}
      this.table_data_options.forEach((tableDataOption) => {
        multiRowTableDataByTab[tableDataOption.id] = []
        allTableData.forEach((row) => {
          var rowForTab = {}
          this.multi_row_table_columns[tableDataOption.id].forEach((column) => {
            if (!row[column.field]) {
              rowForTab[column.field] = 0
            } else {
              rowForTab[column.field] = row[column.field]
            }
          })
          if (row['GameId']) {
            rowForTab['GameId'] = row['GameId']
          }
          if (row['EntityId']) {
            rowForTab['EntityId'] = row['EntityId']
          }
          if (row['Name']) {
            rowForTab['Name'] = row['Name']
          }
          if (row['RowId']) {
            rowForTab['RowId'] = row['RowId']
          }
          if (row['TeamId']) {
            rowForTab['TeamId'] = row['TeamId']
          }
          multiRowTableDataByTab[tableDataOption.id].push(rowForTab)
        })
      })

      this.multi_row_table_data = multiRowTableDataByTab

      this.multi_row_table_columns = updatedColumns
    },
    changeColumnType (columns, typeKey) {
      columns.forEach((column) => {
        if (Object.keys(this.rate_stat_details).indexOf(column['field']) > -1) {
          column['type'] = this.rate_stat_details[column['field']][typeKey]
        }
      })
      return columns
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/StatTypeSelect.vue